import * as React from 'react'
import Select from 'react-select'

export interface IValidableSelect extends React.ComponentProps<typeof Select> {
  invalid?: boolean
  valid?: boolean
}

const ValidableSelect = React.forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (props: IValidableSelect, ref: React.Ref<any>) => {
    return (
      <Select
        {...props}
        className={`react-select-container ${
          props.valid ? 'valid' : props.invalid ? 'invalid' : ''
        }`}
        classNamePrefix="react-select"
        ref={ref}
      />
    )
  }
)

ValidableSelect.displayName = 'ValidableSelect'

export default ValidableSelect
